import { IMarket } from "@/models/IMarket";

import { BaseRepository } from "@/repositories/BaseRepository";

class MarketRepository extends BaseRepository<IMarket> {
    constructor() {
        super("/markets");
    }
}

const marketRepository = new MarketRepository();

export { MarketRepository, marketRepository };
